import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import RouteSeo from './components/RouteSeo';
import { trackPageview } from './lib/marketingApi';
import { cn } from '@/lib/utils';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}

function PageviewTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => trackPageview(pathname), 350);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
}

function Shell() {
  const { theme } = useTheme();
  return (
    <div className={cn('bp-site', theme === 'dark' && 'dark')}>
      <div className="min-h-screen bg-white text-slate-900 antialiased dark:bg-[#0a0a0b] dark:text-slate-100">
        <ScrollToTop />
        <PageviewTracker />
        <RouteSeo />
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default function MarketingLayout() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Shell />
      </LanguageProvider>
    </ThemeProvider>
  );
}
